module.exports = __webpack_public_path__ + "static/img/Eddie-McGuire.31e2f73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Eddie-McGuire.jpg
// module id = kDNm
// module chunks = 1